export type RouteCapabilityStatus = 'live' | 'guided_pilot_only' | 'gated' | 'preview' | 'deferred' | 'static_stub';

export interface RouteCapabilityDecision {
  capabilityId: string;
  status: RouteCapabilityStatus;
  routePattern: string;
  label: string;
  evidenceRequired: string[];
  reason: string;
}

const DEFAULT_STATIC_STUB_EVIDENCE = [
  'Backend persistence contract',
  'End-to-end acceptance evidence',
];

export const ROUTE_CAPABILITIES: Record<string, RouteCapabilityDecision> = {
  'route.operator-onboarding': {
    capabilityId: 'route.operator-onboarding',
    status: 'guided_pilot_only',
    routePattern: '/operator-waitlist',
    label: 'OPERATOR BETA · APPLICATION REQUIRED',
    evidenceRequired: ['Zoe-admin approval', 'Email-bound redemption'],
    reason: 'Operator access is waitlist-gated; approved accounts receive an empty desk until F-12.2.',
  },
  'route.claim-add': {
    capabilityId: 'route.claim-add',
    status: 'static_stub',
    routePattern: '/deal/:codename/claim/add',
    label: 'DESIGN PREVIEW · STATIC STUB',
    evidenceRequired: DEFAULT_STATIC_STUB_EVIDENCE,
    reason: 'Manual claim persistence ships in a later provenance slice.',
  },
  'route.nudge': {
    capabilityId: 'route.nudge',
    status: 'static_stub',
    routePattern: '/deal/:codename/nudge',
    label: 'DESIGN PREVIEW · STATIC STUB',
    evidenceRequired: DEFAULT_STATIC_STUB_EVIDENCE,
    reason: 'Nudge sending/audit semantics are not wired for pilot.',
  },
};

const SLUG_TO_CAPABILITY_ID: Record<string, string> = {
  'ideal-operator-stub': 'route.operator-onboarding',
  'ideal-claim-add': 'route.claim-add',
  'ideal-nudge': 'route.nudge',
};

export function capabilityForSlug(slug: string): RouteCapabilityDecision | undefined {
  const id = SLUG_TO_CAPABILITY_ID[slug];
  return id ? ROUTE_CAPABILITIES[id] : undefined;
}
